module.exports = __webpack_public_path__ + "static/media/qr-method.b8aa5ef1.svg";